import Header from "./../header/Header.vue";
import Footer from "./../footer/Footer.vue";
import Slider from "./../slider/Slider.vue";
import moment from "moment";
import "moment/locale/pl";

export default {
  name: "NewsCard",
  components: {
    Header,
    Footer,
    News: require("../news/News.vue").default,
    Slider
  },
  data() {
    return {
      newsObj: {},
      newsData: {},
      newsContent: "",
      firstSixNews: [],
      hideBtn: false
    };
  },
  filters: {
    formatDate: function(value) {
      if (value) {
        return moment(String(value)).format("LL");
      }
    },
    truncate: function(text, stop) {
      return text.slice(0, stop);
    }
  },
  methods: {
    getData() {
      this.$http
        .get(
          "https://app.umw.edu.pl/headless/wp-json/wp/v2/posts?categories=2&_embed&per_page=100"
        )
        .then(function(data) {
          this.newsData = JSON.parse(JSON.stringify(data)).body;
          this.showNews();
          window.scrollTo({ top: 0, behavior: "smooth" });
        });
    },
    showNews() {
      if (this.newsData.length > 6) {
        for (let news of this.newsData) {
          if (this.firstSixNews.length < 6) this.firstSixNews.push(news);
        }
      } else {
        this.firstSixNews = this.newsData;
        this.hideBtn = true;
      }
    },
    showMoreNews() {
      let newsIndex = this.firstSixNews.length;
      let index = newsIndex;
      while (this.firstSixNews.length < newsIndex + 6) {
        if (index < this.newsData.length) {
          this.firstSixNews.push(this.newsData[index]);
        } else {
          this.hideBtn = true;
          break;
        }
        index = index + 1;
      }
      if (this.firstSixNews.length == this.newsData) this.hideBtn = true;
    }
  },
  created() {
    this.getData();
  }
};
